// Get dates from /available-delivery-slots endpoint
export var getDates = function (slots) {
    var toStartOfDay = function (input) {
        var date = typeof input === 'string' ? new Date(input) : input;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };
    // Treat a day as "available" if it appears in the list (by startDateTime day)
    var availableDayTimes = Array.from(new Set(slots.map(function (slot) { return toStartOfDay(slot.startDateTime).getTime(); })));
    var minTime = Math.min.apply(Math, availableDayTimes);
    var maxTime = Math.max.apply(Math, availableDayTimes);
    var minDate = new Date(minTime);
    var maxDate = new Date(maxTime);
    // Build every day in the [minDate..maxDate] range
    var msPerDay = 24 * 60 * 60 * 1000;
    var totalDays = Math.floor((maxTime - minTime) / msPerDay) + 1;
    var allDays = Array.from({ length: totalDays }, function (any_, i) {
        return new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate() + i);
    });
    // Unavailable = days not present in the available set
    var availableSet = new Set(availableDayTimes);
    var unavailableDates = allDays.filter(function (day) { return !availableSet.has(day.getTime()); });
    return { minDate: minDate, maxDate: maxDate, unavailableDates: unavailableDates };
};
export var findSlotIdByDay = function (slots, day) {
    var _a, _b;
    var startOfDayTime = function (value) {
        var date = typeof value === 'string' ? new Date(value) : value;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
    };
    var target = startOfDayTime(day);
    return ((_b = (_a = slots.find(function (slot) { return startOfDayTime(slot.startDateTime) === target; })) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null);
};
